module.exports = __webpack_public_path__ + "static/media/ins7.e0058939.jpg";